<template>
<div>
    <h1 class="mb-4 text-gray-500">Eporner Downloader</h1>

    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with Eporner downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>

    <eporner-faq></eporner-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Eporner Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Eporner Downloader is a free Chrome extension that allows you to download videos from Eporner for offline viewing. Save your favorite content directly to your device in high quality.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does Eporner Downloader work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Eporner Downloader uses a browser extension to detect and extract video URLs from Eporner pages. Simply copy the video link, paste it into the downloader interface, and the extension will find the downloadable video files.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Do I need to install any software?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'No additional software is required beyond the Chrome extension. Everything runs directly in your browser, making it lightweight and easy to use without consuming system resources.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'What formats are supported by Eporner Downloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Eporner Downloader supports downloading videos in MP4 format, which is compatible with virtually all devices and media players. Videos are saved in their original resolution and quality.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free Eporner Downloader - Download Videos from Eporner',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos from Eporner for free using our Chrome extension. Save videos in original quality for offline viewing. Fast and easy to use.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'eporner downloader, download eporner videos, eporner video downloader, free eporner downloader, eporner chrome extension'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/eporner-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>
